export const ButtonVariant = {
  'default': 'default',
  'default-red': 'default-red',
  'green': 'green',
  'blue': 'blue',
  'light-blue': 'light-blue',
  'red': 'red',
  'link': 'link',
  'link-red': 'link-red',
  'plain': 'plain',
} as const

export const ButtonSize = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
} as const
